// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2mWqt","header":"MessagesList_header__2_08U","chat":"MessagesList_chat__kjZzA"};